import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "../Modals/Loading";
import { FaArrowLeft } from "react-icons/fa6";
import moment from "moment";
import transactionService from "../Services/transactionService";
import Dropdown from "../Components/Dropdown";

const Transactions = () => {
  const navigate = useNavigate();
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterMonth, setFilterMonth] = useState(moment().format("YYYY-MM"));
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filter, setFilter] = useState("month");
  const [balance, setBalance] = useState(0);

  const calculateBalance = (transactions) => {
    return transactions.reduce((balance, item) => {
      if (item.transaction_type === "CREDIT") {
        return balance + parseFloat(item.amount);
      } else if (item.transaction_type === "DEBIT") {
        return balance - parseFloat(item.amount);
      }
      return balance;
    }, 0);
  };

  useEffect(() => {
    transactionService
      .fetchAllBySpecificDate({
        startDate: startDate ? startDate : null,
        endDate: endDate ? endDate : null,
      })
      .then((res) => {
        setFilteredData(res.transactions);
        const totalBalance = calculateBalance(res.transactions);
        setBalance(totalBalance);
      });
  }, [startDate, endDate]);

  useEffect(() => {
    if (filter === "month") {
      transactionService
        .fetchByMonth({ date: filterMonth })
        .then((res) => {
          setFilteredData(res.transactions);
          const totalBalance = calculateBalance(res.transactions);
          setBalance(totalBalance);
        })
        .catch((err) => console.error("Error fetching by month:", err));
    } else {
      transactionService
        .fetchAllBySpecificDate({
          startDate: startDate ? startDate : null,
          endDate: endDate ? endDate : null,
        })
        .then((res) => {
          setFilteredData(res.transactions);
          const totalBalance = calculateBalance(res.transactions);
          setBalance(totalBalance);
        });
    }
  }, [filter]);

  const handleMonthChange = (e) => {
    const selectedMonth = e.target.value;
    setFilterMonth(selectedMonth);
    transactionService
      .fetchByMonth({ date: selectedMonth })
      .then((res) => {
        setFilteredData(res.transactions);
        const totalBalance = calculateBalance(res.transactions);
        setBalance(totalBalance);
      })
      .catch((err) => console.error("Error fetching by month:", err));
  };

  useEffect(() => {
    setLoading(true);
    transactionService.fetchByMonth({ date: filterMonth }).then((res) => {
      setFilteredData(res.transactions);
      const totalBalance = calculateBalance(res.transactions);
      setBalance(totalBalance);
      setLoading(false);
    });
  }, []);

  return (
    <div className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      {loading ? (
        <Loading />
      ) : (
        <div>
          <div className="flex justify-between">
            <p className="font-bold text-3xl text-secondary">
              Transaction History
            </p>
            <div>
              <Dropdown
                selected={filter}
                placeholder="Select Filter"
                onChange={(value) => setFilter(value)}
                options={[
                  { label: "Filter by date", value: "date" },
                  { label: "Filter by month", value: "month" },
                ]}
              />
            </div>
          </div>
          <div className="mt-4">
            {filter === "date" ? (
              <div className="flex gap-8">
                <div className="flex flex-col gap-1">
                  <label className="primary-label">Start Date</label>
                  <input
                    type="date"
                    name="from"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="primary-input"
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <label className="primary-label">End Date</label>
                  <input
                    type="date"
                    name="from"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="primary-input"
                  />
                </div>
              </div>
            ) : (
              <div className="grid gap-1 grid-cols-5">
                <input
                  type="month"
                  id="monthFilter"
                  value={filterMonth}
                  onChange={handleMonthChange}
                  className="primary-input"
                />
              </div>
            )}
          </div>
          <div className="table-div">
            <table>
              <thead>
                <tr className="border-y-2 text-left w-full text-black text-[10px]">
                  <th className="rounded-tl-xl w-[1%] py-4 pl-4">Sr No.</th>
                  <th className="rounded-tl-xl w-[2%] py-4">Date</th>
                  <th className="w-[2%] py-4 ">Transaction Type</th>
                  <th className="w-[2%] py-4 ">Amount</th>
                  <th className="rounded-tr-xl w-[4%] py-4 ">Note / Voucher</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  <>
                    {filteredData?.map((transaction, index) => (
                      <tr
                        key={index}
                        className="bg-accent border-b border-gray-100 text-left"
                      >
                        <td className="py-4 w-[1%] pl-4 font-bold text-blue-500">
                          {index + 1}.
                        </td>
                        <td className="py-4 w-[2%] font-bold">
                          {moment(transaction.date).format("YYYY-MM-DD")}
                        </td>
                        <td className="py-4 w-[2%]">
                          {transaction.transaction_type
                            ? transaction.transaction_type
                            : "-"}
                        </td>
                        <td className="py-4 w-[3%] text-teal-600 font-semibold">
                          {parseFloat(transaction.amount).toFixed(2)} AED
                        </td>
                        <td className="py-4 w-[8%] text-[10px] font-semibold">
                          {transaction?.note ? transaction.note : "-"}
                        </td>
                      </tr>
                    ))}
                  </>
                ) : (
                  "No Transactions to show"
                )}
              </tbody>
            </table>
          </div>
          <div className="font-bold text-gray-500 text-lg">
            End Balance :{" "}
            <span className="text-teal-600">{Number(balance).toFixed(2)}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Transactions;
